<template>
  <asc-chart :options="getChartOptions"></asc-chart>
</template>

<script>
import AscChart from './AscChart'

export default {
  name: 'AscSparklineChart',

  components: {
    AscChart,
  },

  props: {
    values: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      defaultOptions: {
        chart: {
          backgroundColor: null,
          borderWidth: 0,
          type: 'line',
          margin: [2, 2, 2, 2],
          height: 24,
          width: 100,
          style: {
            overflow: 'visible',
          },
          skipClone: true,
        },
        title: {
          text: '',
        },
        xAxis: {
          labels: {
            enabled: false,
          },
          title: {
            text: null,
          },
          startOnTick: false,
          endOnTick: false,
          tickPositions: [],
        },
        yAxis: {
          endOnTick: false,
          startOnTick: false,
          labels: {
            enabled: false,
          },
          title: {
            text: null,
          },
          tickPositions: [0],
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          hideDelay: 0,
          outside: true,
          shared: true,
        },
        plotOptions: {
          series: {
            animation: false,
            lineWidth: 1,
            shadow: false,
            states: {
              hover: {
                lineWidth: 1,
              },
            },
            marker: {
              radius: 2,
              states: {
                hover: {
                  radius: 2,
                },
              },
            },
          },
        },
        series: [
          {
            data: [],
            pointStart: 1,
          },
        ],
      },
      chartWidth: 0,
    }
  },

  computed: {
    getChartOptions() {
      if (this.values.length) {
        const series = this.buildSeries
        const options = {
          ...this.defaultOptions,
          ...series,
        }
        return options
      }
      return this.defaultOptions
    },

    buildSeries() {
      return {
        series: [
          {
            data: this.values,
            tooltip: {
              headerFormat: '',
              pointFormat: '<b>{point.y}</b>',
            },
          },
        ],
      }
    },
  },

  methods: {
    handleResize(e) {
      this.chartWidth = e.detail.width
    },
  },
}
</script>
